module.exports = __webpack_public_path__ + "static/media/list-user-search.c7eb98ac.svg";